import { FooterLinks, FooterText, FooterWrapper } from "./Footer.style";

import { FaGithub, FaLinkedin } from "react-icons/fa";
import { Li, SocialMediaLink, Ul } from "../../pages/about/About.style";

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterText>Site desenvolvido por João Paulo &copy; 2022</FooterText>
      <FooterLinks>
        <Ul>
          <Li>
            <SocialMediaLink
              href="https://github.com/jpcchaves"
              target="_blank"
            >
              <FaGithub />
            </SocialMediaLink>
          </Li>
          <Li>
            <SocialMediaLink
              href="https://www.linkedin.com/in/joaopaulo-chaves/"
              target="_blank"
            >
              <FaLinkedin />
            </SocialMediaLink>
          </Li>
        </Ul>
      </FooterLinks>
    </FooterWrapper>
  );
};

export default Footer;
